import {Row, Col} from 'react-bootstrap';
import ChartEvolucion from '../common/ChartEvolucion';
import {parseNumero, parseNumeroEntero} from '../../utils/NumberUtils';

function ReporteEvolucionVentasCRMChartJS({ventas, titulos, moneda}) {
    console.log(ventas);
    console.log(titulos);
    let labels;
    let labelCantidadPedidos;
    let labelVentas;
    let labelComisiones;
    let datosCantidadPedidos;
    let datosVentas;
    let datosComisiones;

    if (titulos.length == 4) {
        labels = ventas.map((elem) => elem.mesEnLetras);
        console.log(labels);

        labelCantidadPedidos = labels.slice(0, labels.length);
        datosCantidadPedidos = ventas.map((elem) => parseNumeroEntero(elem.cantidad)).slice(0, labels.length);
        //console.log(datosCantidadPedidos);

        labelVentas = labels.slice(0, labels.length);
        datosVentas = ventas.map((elem) => parseNumero(elem.total)).slice(0, labels.length);
        console.log(datosVentas);

        labelComisiones = labels.slice(0, labels.length);
        datosComisiones = ventas.map((elem) => parseNumero(elem.comisiones)).slice(0, labels.length);
        console.log(datosComisiones);
    } else {
        labels = titulos.slice(1, titulos.length-1).map((elem) => elem.titulo);
        //console.log(labels);

        labelCantidadPedidos = labels.slice(0, labels.length);
        datosCantidadPedidos = Object.values(ventas[0]).map((elem) => parseNumeroEntero(elem)).slice(0, labels.length);
        //console.log(datosCantidadPedidos);

        labelVentas = labels.slice(0, labels.length);
        datosVentas = Object.values(ventas[1]).map((elem) => parseNumero(elem)).slice(0, labels.length);
        //console.log(datosVentas);

        labelComisiones = labels.slice(0, labels.length);
        datosComisiones = Object.values(ventas[2]).map((elem) => parseNumero(elem)).slice(0, labels.length);
        //console.log(datosComisiones);
    }
    
    return (
        <>
        <Row  className='mt-4'>
            <Col md="6" xs="12">
                <ChartEvolucion 
                    titulo={`Evolución de Ventas en ${moneda ? 'Dólares' : 'Pesos'}`} 
                    labels={labelVentas} 
                    serie={datosVentas} tituloSerie="Ventas"/>
            </Col>
            <Col md="6" xs="12">
                <ChartEvolucion 
                    titulo={`Evolución de Comisiones en ${moneda ? 'Dólares' : 'Pesos'}`} 
                    labels={labelComisiones} 
                    serie={datosComisiones} tituloSerie="Comisiones"/>
            </Col>
        </Row>
        <Row className='mt-4 mb-4'>
            <Col md="3" xs="0"></Col>
            <Col md="6" xs="12">
            <ChartEvolucion 
                    titulo="Evolución de Cantidad de Pedidos" 
                    labels={labelCantidadPedidos} 
                    serie={datosCantidadPedidos} tituloSerie="Cantidad de Pedidos"/>
            </Col>
        </Row>
        </>
    );
}

export default ReporteEvolucionVentasCRMChartJS;